<template>
  <header
    class="navbar"
    :class="{ scrolled: isScrolled }"
  >
    <div class="navbar-container">

      <!-- Logo -->
      <Logo />

      <!-- Desktop Navigation -->
      <NavbarLinks />

      <!-- Desktop Actions -->
      <div class="navbar-actions">
        <ThemeToggle />
        <NavbarActions />
      </div>

      <!-- Mobile Toggle -->
      <button
        type="button"
        class="navbar-toggle"
        :class="{ active: isMenuOpen }"
        aria-label="Toggle navigation"
        :aria-expanded="isMenuOpen"
        @click="toggleMenu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

    </div>

    <!-- Mobile Menu -->
    <Transition name="mobile-menu">
      <div
        v-if="isMenuOpen"
        class="mobile-menu"
      >

        <!-- Mobile Navigation -->
        <nav class="mobile-menu-links">

          <RouterLink
            to="/"
            class="mobile-menu-link"
            @click="closeMenu"
          >
            {{ $t('navbar.home') }}
          </RouterLink>

          <RouterLink
            to="/about"
            class="mobile-menu-link"
            @click="closeMenu"
          >
            {{ $t('navbar.about') }}
          </RouterLink>

          <RouterLink
            to="/how-it-works"
            class="mobile-menu-link"
            @click="closeMenu"
          >
            {{ $t('navbar.works') }}
          </RouterLink>


          <RouterLink
            to="/pricing"
            class="mobile-menu-link"
            @click="closeMenu"
          >
            {{ $t('navbar.pricing') }}
          </RouterLink>

          <RouterLink
            to="/contact"
            class="mobile-menu-link"
            @click="closeMenu"
          >
            {{ $t('navbar.contact') }}
          </RouterLink>

        </nav>

        <!-- Mobile Actions -->
        <div class="mobile-menu-actions">

          <!-- Theme Toggle -->
          <ThemeToggle />

          <!-- Login -->
          <RouterLink
            to="/login"
            class="navbar-login"
            @click="closeMenu"
          >
            {{ $t('navbar.login') }}
          </RouterLink>

        </div>

      </div>
    </Transition>
  </header>
</template>

<script>
import Logo from '@/components/common/Logo.vue'
import ThemeToggle from '@/components/common/ThemeToggle.vue'
import NavbarLinks from '@/components/layout/navbar/NavbarLinks.vue'
import NavbarActions from '@/components/layout/navbar/NavbarAction.vue'

export default {
  name: 'NavbarComponent',

  components: {
    Logo,
    ThemeToggle,
    NavbarLinks,
    NavbarActions
  },

  data() {
    return {
      isMenuOpen: false,
      isScrolled: false
    }
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    this.handleScroll()
  },

  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  },

  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
    },

    closeMenu() {
      this.isMenuOpen = false
    },

    handleScroll() {
      this.isScrolled = window.scrollY > 10
    }
  }
}
</script>